'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';

export default function WhatsAppWidget() {
  const pathname = usePathname();
  const isDashboard = pathname?.startsWith('/dashboard');

  if (isDashboard) {
    return null;
  }

  return (
    <Script
      src="https://whatsform.com/launcher.js"
      id="wf-widget"
      data-id="zkwhoo"
      data-message="Message on WhatsApp"
      strategy="lazyOnload"
    />
  );
}
